import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SelectedInviteBlockView = props => /*#__PURE__*/_jsx("div", {
  className: "col-11",
  children: /*#__PURE__*/_jsxs("div", {
    className: "flex-container box",
    style: {
      border: '3px solid #eee'
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "col-md-3 box border right",
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: `project.role.${props.invitee.role}.title`
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-md-3 box border right",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inline-container column",
        children: [/*#__PURE__*/_jsx("strong", {
          children: props.invitee.fullName || props.invitee?.organisationName
        }), /*#__PURE__*/_jsx("span", {
          children: props.invitee.registrationNumber
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-md-3 box border right",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inline-container column",
        children: [/*#__PURE__*/_jsx("span", {
          children: props.invitee.address?.addressLine || props.invitee.phoneNumber
        }), props.invitee.address && /*#__PURE__*/_jsxs("span", {
          children: [props.invitee.address?.postCode, " ", props.invitee.address?.city]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-md-3 box border none",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inline-container column",
        children: [/*#__PURE__*/_jsx("span", {
          children: props.invitee.email || props.invitee.user.email
        }), /*#__PURE__*/_jsxs("span", {
          children: [props.invitee.firstName || props.invitee.user.firstName, " ", props.invitee.lastName || props.invitee.user.lastName]
        })]
      })
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      "data-id": "delete-selected-invitee",
      className: "large secondary",
      onClick: () => props.onRemoveInviteeClick(props.invitee),
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "trash"
      })
    })]
  })
});
SelectedInviteBlockView.propTypes = {
  invitee: PropTypes.object.isRequired,
  onRemoveInviteeClick: PropTypes.func.isRequired
};
export default SelectedInviteBlockView;